import script from "./JournalAddOwn.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalAddOwn.vue?vue&type=script&setup=true&lang=js"

import "./JournalAddOwn.vue?vue&type=style&index=0&id=11e56044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e56044"]])

export default __exports__